import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/user/revokeSessions/user.revokeSessions.mutation.gql"
import type {
  UserRevokeSessionsMutation,
  UserRevokeSessionsMutationVariables,
} from "@/v2-backoffice-client/user/revokeSessions/__types__/user.revokeSessions.mutation"

type Options = MutationHookOptions<
  UserRevokeSessionsMutation,
  UserRevokeSessionsMutationVariables
>

export function useUserRevokeSessionsMutation(options?: Options) {
  return useMutation<
    UserRevokeSessionsMutation,
    UserRevokeSessionsMutationVariables
  >(mutation, options)
}
